import { render, staticRenderFns } from "./ItemDetailAmountLayout.vue?vue&type=template&id=cbe1c8d0&scoped=true"
import script from "./ItemDetailAmountLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailAmountLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe1c8d0",
  null
  
)

export default component.exports